// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3oI2f","title":"Info_title__1mSrZ","selects":"Info_selects__16duO","requiredAsterisk":"Info_requiredAsterisk__i20Bp"};